import './App.css';
import React,  {Alert,Component} from 'react';
import logo from './logo _exotic.png';
import { useRef, useState } from "react";
import { Nav,Navbar,Form,Button,Container,Row,Col,NavDropdown,Card,Modal} from 'react-bootstrap';
import { BrowserRouter as Router, Switch, Route, Link,Redirect,HashRouter } from 'react-router-dom';
import Bounce from 'react-reveal/Bounce';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Zoom from 'react-reveal/Zoom';
import Carousel from 'react-bootstrap/Carousel';
import { FaArrowUp } from "react-icons/fa6";
import { BrowserView, MobileView, isBrowser, isMobile} from "react-device-detect";
import Accueil from './components/Accueil';
import Menu from './components/Menu';



class App extends Component{
    
  constructor(props) {
  super(props);
    this.state = {
      loaddata : true,
      show: false,
      setShow: false,
      isModalVisible: false,
      isModalloderVisible : true,
      accueiltitre: '',
      accueilimage: '',
      touteslesarticles: [],
      touteslestours: [],
      gallery: [],
      width: 0,
      height: 0,
      scrollpage:0,
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
      
  }
  
  async componentDidMount() {
    
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    window.addEventListener('scroll', this.updateWindowDimensions);
      
  };

  componentWillUnmount() {

    window.removeEventListener('resize', this.updateWindowDimensions);
    window.removeEventListener('scroll', this.updateWindowDimensions);
  }
  
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight, scrollpage: window.scrollY });
  }

  scrolltop(){
    window.scrollTo(0, 0)
  }
  
  render() {

        return (
            
              <div>

                <div style={{position:"fixed", width:"100%", top:0, zIndex: '1000'}}>

                  <Menu />

                </div>


                    
                    {this.state.scrollpage>200 ?

                        <Zoom>
                          <button className="bnttop" onClick={() => this.scrolltop()} style={{width:'50px', height:'50px', marginBottom:"70px",padding:"0%"}}><span><FaArrowUp /></span></button>
                        </Zoom>

                        :

                        null
                    
                    }
                    
                    <Router>

                      <Switch>
                            
                            <Route  path="/" exact component={Accueil}></Route>
                            <Route  path="/Accueil" exact component={Accueil} title="Accueil"></Route>
                                                      
                                                  
                      </Switch>

                  </Router>          

              </div>
        );
      }
  
}

export default App;
